import axios from "axios";
import { toast, Bounce } from "react-toastify";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllValue, getBadge, saveAppealSentDate } from "../../action";
import { getClaims, undoAFCAAppeal, deleteClaim } from "../../action";
import { useAudio } from "../Stores/useAudio";


export const AFCAAppealRow = ({
  address,
  description,
  index,
  claimantId,
  claimantName,
  insurer,
  status,
  appealSentData,
  afcaAppealMadeDate,
  timestamps
}) => {
  const jwtToken = localStorage.getItem("jwtToken");
  const [modalOpen, setModalOpen] = useState(false);
  const [appealDate, setAppealDate] = useState('');
  const [date, setDate] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dispatch = useDispatch();
  const state = useSelector((state) => state.reducer);
  const [afcaFinalMadeDate, setAfcaFinalMadeDate] = useState('');
  const { setAudioURL } = useAudio();
  const [open, setOpen] = useState(false);

  const keys = timestamps ? Object.keys(timestamps).sort((a, b) => new Date(timestamps[a]) - new Date(timestamps[b])) : [];
  const results = keys.map((key) => {
    const currentDate = new Date(timestamps[key]);
    const today = new Date();
    const diffTime = Math.abs(today - currentDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return { timestamp: key, daysAgo: diffDays };
  });
  useEffect(() => {
    if (afcaAppealMadeDate) {
      const dateObj = new Date(afcaAppealMadeDate);
      const today = new Date();
      const origianlDate = new Date(dateObj.toDateString());
      const todayDateOnly = new Date(today.toDateString());
      const diffTime = todayDateOnly - origianlDate;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      setAfcaFinalMadeDate(diffDays);
    }
  }, [afcaAppealMadeDate]);
  

  useEffect(() => {
    if (appealSentData) {
      const dateObj = new Date(appealSentData);
      const today = new Date();
      const origianlDate = new Date(dateObj.toDateString());
      const todayDateOnly = new Date(today.toDateString());
      const diffTime = todayDateOnly - origianlDate;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      setAppealDate(diffDays);
    }
  }, [appealSentData]);

  const handleDecideAFCAAppeal = (status) => {
    if (status === "authorize") {
      axios
        .post(
          `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/afca-appeal-decision`,
          { decision: "approved" },
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.message)
            toast.success(res.data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              transition: Bounce,
            });
          dispatch(getClaims());
          
          dispatch(getAllValue());
          if (res.data.badgeUnlock.includes("Appeal Winner") ) {
            dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by Win 3 AFCA appeals" })
            setAudioURL(["/sounds/badge/badge28.mp3"]);
          } else if (res.data.badgeUnlock.includes("Decline Crusher")) {
            dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by Overturning a denied claim" })
            setAudioURL(["/sounds/badge/badge6.mp3"]);
          } else if (res.data.badgeUnlock !== "") {
            dispatch({ type: "SET_BADGE_GIFT", payload: `added ${res.data.badgeUnlock} badges!` })
            setAudioURL(["/sounds/badge/badge20.mp3"]);
          } else {
            dispatch({ type: "SET_GIFT" });
            dispatch({ type: "SET_AUDIO" });
          }
          dispatch(getBadge());
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (status === "lost") {
      axios.post(`https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/afca-appeal-decision`,{ decision: "denied" },
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.message)
            toast.success(res.data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              transition: Bounce,
            });
          dispatch(getClaims());
          dispatch(getAllValue());
          if (res.data.badgeUnlock === "Power Closer") {
            dispatch({ type: "SET_BADGE_GIFT", payload: "You’ve earned this badge simply by Closing 25 claims" });
            setAudioURL(["/sounds/badge/badge12.mp3"]);
          } else {
            dispatch({ type: "SET_AUDIO_OH" });
            dispatch({ type: "SET_NO_GIFT" });
          }
          dispatch(getBadge());
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <tr key={index} className="border-t">
      <td className="px-6 py-4 text-center">{address}</td>
      <td className="px-6 py-4 text-center">{claimantName}</td>
      <td className="px-6 py-4 text-center">{insurer}</td>
      <td className="px-6 py-4 text-center">{description}</td>
      <td className="px-6 py-4 text-center relative">
        <div
            className="bg-blue-50 hover:bg-blue-100 px-2 py-1 border border-blue-100 rounded-2xl w-max mx-auto text-blue-700 cursor-pointer"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
          >
            {status}
            {open && (
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-white shadow-lg rounded-xl p-4 w-56 z-10 text-sm">
                {results?.map((item, idx) => (
                  <div key={idx} className="mb-2">
                    <strong>{
                      item.timestamp === "createdAt" ? "Authorized" :   
                      item.timestamp === "assessmentStart" ? "Under Assessment" :
                      item.timestamp === "appealStart" ? "Appeal in Progress" :
                      item.timestamp === "afcaWonDate" ? "Scope of Works" :
                      item.timestamp === "cashSettlementDate" ? "Cash Settlement" :
                      item.timestamp === "eggHatchedDate" ? "Egg Hatched" :
                      item.timestamp === "afcaAppealMadeDate" ? "AFCA Appeal" :
                      item.timestamp === "afcaAppealMadeDate" ? "AFCA Appeal" :
                      item.timestamp === "declinedDate" ? "AFCA Claim Denied" : ""
                    }</strong>: {item.daysAgo} day{item.daysAgo !== 1 && 's'}
                  </div>
              ))}
            </div>
            )}
        </div>
      </td>
      {
        (
          <td className="text-center">
             {appealSentData
                ? `AFCA Complaint Lodgement data sent date (${appealSentData.split("T")[0]})`
                : ""}
          </td>
        )
      }
      <td className="px-6 py-4 text-center">
        {
          state.role === 0 ? (
            <div className="flex flex-col w-60 text-center font-semibold relative">
            {/* Dropdown Trigger Button */}
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="relative w-full px-4 py-2 rounded-md text-sm font-medium bg-gradient-to-br from-blue-500 to-blue-700 shadow-lg hover:scale-105 hover:from-blue-600 hover:to-blue-800 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow"
            >
              <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
              <span className="relative z-10 text-white flex items-center justify-between">
                AFCA Actions
                <svg
                  className={`w-4 h-4 ml-2 transition-transform ${isDropdownOpen ? "rotate-180" : ""}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </span>
            </button>

            {/* Dropdown Menu */}
            {isDropdownOpen && (
              <div className="absolute top-full left-0 mt-1 w-full rounded-md shadow-lg z-10 bg-white border border-gray-200 overflow-hidden">
                <div className="space-y-1 p-1">
                  {/* AFCA Appeal Sent Button */}
                  <button
                    className="relative w-full px-4 py-2 rounded-md text-sm font-medium bg-gradient-to-br from-red-400 to-red-600 shadow-lg hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow"
                    onClick={() => {
                      setModalOpen(true);
                      setIsDropdownOpen(false);
                    }}
                  >
                    <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                    <span className="relative z-10 text-white">AFCA Appeal Sent</span>
                  </button>

                  {/* Won Button */}
                  <button
                    onClick={() => {
                      handleDecideAFCAAppeal("authorize");
                      setIsDropdownOpen(false);
                    }}
                    className="relative w-full px-4 py-2 rounded-md text-sm font-medium bg-gradient-to-br from-green-400 to-green-600 shadow-lg hover:scale-105 hover:from-green-500 hover:to-green-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow"
                  >
                    <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                    <span className="relative z-10 text-white">Won</span>
                  </button>

                  {/* Lost Button */}
                  <button
                    onClick={() => {
                      handleDecideAFCAAppeal("lost");
                      setIsDropdownOpen(false);
                    }}
                    className="relative w-full px-4 py-2 rounded-md text-sm font-medium bg-gradient-to-br from-red-400 to-red-600 shadow-lg hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow"
                  >
                    <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                    <span className="relative z-10 text-white">Lost</span>
                  </button>

                  {/* Undo Button */}
                  <button
                    onClick={() => {
                      dispatch(undoAFCAAppeal(claimantId, "undo", jwtToken));
                      setIsDropdownOpen(false);
                    }}
                    className="relative w-full px-4 py-2 rounded-md text-sm font-medium bg-gradient-to-br from-yellow-400 to-orange-600 shadow-lg hover:scale-105 hover:from-yellow-500 hover:to-orange-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow"
                  >
                    <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                    <span className="relative z-10 text-white">Undo</span>
                  </button>
                </div>
              </div>
            )}

            {/* Modal (unchanged from original) */}
            <div
              className={`fixed left-0 top-0 flex h-full min-h-screen w-full items-center justify-center z-20 bg-dark/90 px-4 py-5 ${
                modalOpen ? "block" : "hidden"
              }`}
            >
              <div className="flex flex-col gap-y-4 bg-white dark:bg-dark-2 shadow-xl p-4 rounded-[20px] w-full max-w-[570px] text-center">
                <div className="w-full bg-white rounded-lg overflow-hidden">
                  <div className="px-6 py-4">
                    <h2 className="text-xl font-bold text-gray-900">
                      Record AFCA Complaint
                    </h2>
                  </div>
                  <div className="px-6 py-4 bg-amber-50">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <div className="w-1 bg-amber-400 h-full rounded-full mr-3"></div>
                      </div>
                      <p className="text-amber-700 text-sm">
                        This action can only be performed once. The deadline for appeal
                        decision is 30 calendar days. Make sure you have actually sent
                        the AFCA Complaint Lodgement before recording it here.
                      </p>
                    </div>
                  </div>
                  {/* <form className="px-6 py-4">
                    <div className="mb-6">
                      <label
                        htmlFor="afcaDate"
                        className="block text-sm font-medium text-gray-700 mb-2"
                      >
                        When did you send the AFCA Complaint Lodgement?
                      </label>
                      <div className="relative">
                        <input
                          type="date"
                          datatype="y-m-d"
                          className="p-2 border w-full"
                          onChange={(e) => setDate(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="flex justify-end space-x-2 mt-6">
                      <button
                        type="button"
                        className="px-4 py-2 bg-white text-gray-700 font-medium rounded-md border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        onClick={() => {
                          setModalOpen(false);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="px-4 py-2 bg-red-600 text-white font-medium rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                        onClick={() => {
                          setModalOpen(false);
                          dispatch(saveAppealSentDate(date, claimantId));
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </form> */}
                  <form className="px-6 py-4">
                    <div className="mb-6">
                      <label
                        htmlFor="afcaDate"
                        className="block text-sm font-medium text-gray-700 mb-2"
                      >
                        When did you send the AFCA Complaint Lodgement?
                      </label>
                      <div className="relative">
                        <input
                          type="date"
                          id="afcaDate"              // ← added
                          name="afcaDate"            // ← added
                          className="p-2 border w-full"
                          onChange={(e) => setDate(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="flex justify-end space-x-2 mt-6">
                      <button
                        type="button"
                        className="px-4 py-2 bg-white text-gray-700 font-medium rounded-md border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        onClick={() => setModalOpen(false)}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="px-4 py-2 bg-red-600 text-white font-medium rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                        onClick={() => {
                          setModalOpen(false);
                          dispatch(saveAppealSentDate(date, claimantId));
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          ) : (
            <button
              onClick={(e) => dispatch(deleteClaim(claimantId, state.currentUserName))}
              className="relative px-5 py-2  tracking-wide text-white uppercase rounded-lg bg-gradient-to-br from-red-400 to-red-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl active:scale-95 animate-pulse-glow"
            >
              <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
              <span className="relative z-10">Delete</span>
            </button>
          )
        }
        
      </td>
      <td className="text-center">
        {
          afcaFinalMadeDate === 0 ? "Today" : (`${afcaFinalMadeDate} days`)
        }
      </td>
      
    </tr>
  );
};